import { useEffect } from "react";
import { BRAND_CONFIGURATION } from "../../../../../configs/brands";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";
import { useElapsed } from "../../../../utils/useElapsed";
import { useNotificationPermission } from "../../../../utils/useNotificationPermission";
const { airship } = BRAND_CONFIGURATION;
const KEY = "airship";
export const useInitAirship = () => {
    const { dispatch } = useOverlayOrchestrator();
    const permission = useNotificationPermission();
    const canProceed = useOverlayStepsOrchestrator(KEY);
    const active = Boolean(airship && canProceed);
    const isElapsed = useElapsed({ active, duration: 15 });
    useEffect(() => {
        if (isElapsed) {
            dispatch({ type: "INIT", payload: KEY });
        }
    }, [isElapsed, dispatch]);
    useEffect(() => {
        if (["granted", "denied"].includes(permission)) {
            dispatch({ type: "COMPLETE", payload: KEY });
        }
    }, [permission, dispatch]);
    useEffect(() => {
        if (!airship && canProceed) {
            dispatch({ type: "DISABLE", payload: KEY });
        }
    }, [canProceed, dispatch]);
};
